import { DirectoryModel } from './directory-model.model';

export class ChangeFileOrder {
    oldPath: string;
    newPath: string;
    directoryOrFile: DirectoryModel;

    constructor(oldPath: string, newPath: string, dm: DirectoryModel) {
        this.oldPath = oldPath;
        this.newPath = newPath;
        this.directoryOrFile = dm;
    }
}
